import BASE_URL from "../config";

// Reviews for a single product (Public) — rating, message, reviewer name only.
export const getProductReviews = async (productId, { page = 1, limit = 10 } = {}) => {
  const params = new URLSearchParams({ page, limit });

  const response = await fetch(
    `${BASE_URL}/products/${productId}/reviews?${params.toString()}`
  );

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

// The logged-in user's own review for this product, if any.
export const getMyReview = async (productId, token) => {
  const response = await fetch(`${BASE_URL}/products/${productId}/reviews/me`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

// Submit a review (Authenticated — one per user per product).
export const createReview = async (productId, { rating, comment }, token) => {
  const response = await fetch(`${BASE_URL}/products/${productId}/reviews`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ rating, comment }),
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

// Update your own review.
export const updateReview = async (reviewId, { rating, comment }, token) => {
  const response = await fetch(`${BASE_URL}/reviews/${reviewId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ rating, comment }),
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

// Delete a review (owner or admin).
export const deleteReview = async (reviewId, token) => {
  const response = await fetch(`${BASE_URL}/reviews/${reviewId}`, {
    method: "DELETE",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

// All reviews across products, for admin management.
export const getAllReviews = async (
  { productId = "", rating = "", search = "", page = 1, limit = 10 } = {},
  token
) => {
  const params = new URLSearchParams({ page, limit });
  if (productId) params.append("productId", productId);
  if (rating) params.append("rating", rating);
  if (search) params.append("search", search);

  const response = await fetch(`${BASE_URL}/reviews?${params.toString()}`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};
